import { render, staticRenderFns } from "./ManageEvent.vue?vue&type=template&id=54b5ce74&scoped=true"
import script from "./ManageEvent.vue?vue&type=script&lang=js"
export * from "./ManageEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5ce74",
  null
  
)

export default component.exports